var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99988 0.841553C4.90897 0.841553 1.41533 3.32955 -0.00012207 6.84155C1.41533 10.3536 4.90897 12.8416 8.99988 12.8416C13.0908 12.8416 16.5844 10.3536 17.9999 6.84155C16.5844 3.32955 13.0908 0.841553 8.99988 0.841553ZM8.99988 10.8416C6.7417 10.8416 4.90897 9.04955 4.90897 6.84155C4.90897 4.63355 6.7417 2.84155 8.99988 2.84155C11.2581 2.84155 13.0908 4.63355 13.0908 6.84155C13.0908 9.04955 11.2581 10.8416 8.99988 10.8416ZM8.99988 4.44155C7.6417 4.44155 6.54533 5.51355 6.54533 6.84155C6.54533 8.16955 7.6417 9.24155 8.99988 9.24155C10.3581 9.24155 11.4544 8.16955 11.4544 6.84155C11.4544 5.51355 10.3581 4.44155 8.99988 4.44155Z",
    fill: "#C1C1C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.bc5143be5e28769e1fb60f8b28e9f2d3.svg";
export { ForwardRef as ReactComponent };